var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotation-ring",attrs:{"data-scroll":"","data-scroll-id":"ring_rotation","data-scroll-offset":"50%"}},[_c('TechnicalData',{ref:"technicalData"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }